// extracted by mini-css-extract-plugin
module.exports = {"servicesContainer":"styles_servicesContainer__3lyNr","servicesContent":"styles_servicesContent__164DG"};